import { useTranslation } from "react-i18next";
import { Button } from "@tellescope/ui";
import { Spinner } from "@tellescope/design-system";
import { formatPhone } from "@tellescope/utils";
import { VerificationEmbed } from "./VerificationEmbed";

export interface VerifyTollFreeNumberViewProps {
  phoneNumber: string;
  embedUrl?: string;
  isLoadingEmbed: boolean;
  hasError: boolean;
  onClose: () => void;
}

export const VerifyTollFreeNumberView = ({
  phoneNumber,
  embedUrl,
  isLoadingEmbed,
  hasError,
  onClose,
}: VerifyTollFreeNumberViewProps) => {
  const { t } = useTranslation("onboarding");

  return (
    <div className="min-h-0 h-full pt-6 pb-4 flex flex-col gap-6">
      <div className="flex items-start justify-between gap-4">
        <div className="flex flex-col gap-1">
          <h3 className="text-xl font-semibold text-gray-900 leading-none">{t("Verify Toll-Free Number")}</h3>
          <p className="text-sm text-muted-foreground">{formatPhone(phoneNumber)}</p>
        </div>
        <Button variant="outline" onClick={onClose}>
          {t("Back to Phone Numbers")}
        </Button>
      </div>
      {isLoadingEmbed ? (
        <div className="flex flex-1 flex-col gap-4 items-center justify-center">
          <Spinner />
          <p className="text-sm text-muted-foreground">{t("Loading verification...")}</p>
        </div>
      ) : hasError || !embedUrl ? (
        <div className="flex flex-1 flex-col gap-4 items-center justify-center">
          <p className="text-sm text-destructive">{t("Failed to load verification. Please try again.")}</p>
        </div>
      ) : (
        <VerificationEmbed key={embedUrl} src={embedUrl} title={t("Toll-free number verification")} />
      )}
    </div>
  );
};
